import { Route } from 'react-router-dom';

import type { ICreditDecisionActivity } from '../types/ICreditDecisionActivity';
import { getAllRoutes } from '../utils/routes';
import CreditDecisionActivity from './CreditDecisionActivity';
import { ActivityRouteContainer } from './CreditDecisionActivity.style';
import { CreditDecisionSlideOut } from './CreditDecisionSlideOut';

const Root = (props: ICreditDecisionActivity) => {
    const { root } = getAllRoutes(props.baseRoute);

    return (
        <>
            <ActivityRouteContainer data-testid="activities-credit-decision-container" className="activities-credit-decision">
                <Route path={root} component={CreditDecisionActivity} />
            </ActivityRouteContainer>
            <CreditDecisionSlideOut />
        </>
    );
};

Root.displayName = 'CreditDecisionActivity';

export default Root;
